module.exports = "/_next/static/images/mobilelending-monotone-83a4b3356115dfa301235e4e42e69374.svg";